import { ensureGeneralLibrary, listDocuments } from "@/apps/rag/api/rag-api";

function stripExtension(name: string): string {
  return name.replace(/\.[^/.]+$/, "") || name;
}

/**
 * Find a single document in the user's General Chat library whose title matches
 * the attached filename (with or without extension). Returns null when zero or
 * multiple documents match so we never open the wrong file.
 */
export async function resolveGeneralChatDocumentId(filename: string): Promise<string | null> {
  const trimmed = filename.trim();
  if (!trimmed) return null;
  const { library } = await ensureGeneralLibrary();
  const stem = stripExtension(trimmed).toLowerCase();
  const full = trimmed.toLowerCase();

  const { documents } = await listDocuments(library.id, {
    page: 1,
    limit: 100,
    q: stem,
  });

  const matches = documents.filter((doc) => {
    const title = (doc.title ?? "").trim().toLowerCase();
    return title === full || title === stem;
  });

  if (matches.length !== 1) return null;
  return matches[0]?.id ?? null;
}
